import styled from 'styled-components';
import GoStayIconSvg from '../assets/hotels/amenities/gostays.svg';

const GoStaysIcon = styled(GoStayIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props =>
    props.fill || props.isActive
      ? props.theme.colors.goBrandOrange.base
      : props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default GoStaysIcon;
